import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const specialtyApi = createApi({
  reducerPath: "specialty",
  tagTypes: ["Specialties"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getSpecialties: builder.query({
      query: () => "api/v2/specialties",
      transformResponse: (response: any) => {
        return response.specialties;
      }
    })
  })
});

export const { useGetSpecialtiesQuery } = specialtyApi;
